var React = require('react');

function CarouselArrowRight (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M46.0607 13.0607C46.6464 12.4749 46.6465 11.5251 46.0607 10.9393L36.5147 1.39341C35.9289 0.80762 34.9792 0.807619 34.3934 1.39341C33.8076 1.97919 33.8076 2.92894 34.3934 3.51473L42.8787 12L34.3934 20.4853C33.8076 21.0711 33.8076 22.0208 34.3934 22.6066C34.9792 23.1924 35.9289 23.1924 36.5147 22.6066L46.0607 13.0607ZM-8.59667e-08 13.5L45 13.5L45 10.5L8.59648e-08 10.5L-8.59667e-08 13.5Z","fill":"#6335CC"}));
}

CarouselArrowRight.defaultProps = {"width":"47","height":"24","viewBox":"0 0 47 24","fill":"none"};

module.exports = CarouselArrowRight;

CarouselArrowRight.default = CarouselArrowRight;
